// extracted by mini-css-extract-plugin
export default {"container":"search-item_container__34SRC","member":"search-item_member__i8N7+","user":"search-item_user__tQNcw","username":"search-item_username__WssyG"};